import PropTypes from 'prop-types';
import { RouteShape } from './Route';
import { WorkzoneShape } from './Workzone';
import { JurisdictionShape } from '../../contact/models/Jurisdiction';
import { ObstacleShape } from './Obstacle';
import { UrbanAreaShape } from './UrbanArea';
import { AirportShape } from './Airport';
import { RightOfWayShape } from './RightOfWay';
import { PipelineCenterlineShape } from './PipelineCenterline';

const Mission = {
  id: PropTypes.number,
  name: PropTypes.string,
  sharedRow: PropTypes.bool,
  jurisdictions: PropTypes.arrayOf(JurisdictionShape),
  routeCount: PropTypes.number,
  routes: PropTypes.arrayOf(RouteShape),
  totalRouteLengthInKilometers: PropTypes.number,
  workzoneCount: PropTypes.number,
  workzones: PropTypes.arrayOf(WorkzoneShape),
  obstacles: PropTypes.arrayOf(ObstacleShape),
  airports: PropTypes.arrayOf(AirportShape),
  urbanAreas: PropTypes.arrayOf(UrbanAreaShape),
  rightOfWays: PropTypes.arrayOf(RightOfWayShape),
  centerlines: PropTypes.arrayOf(PipelineCenterlineShape),
  isDeleted: PropTypes.bool,
  obstacleCount: PropTypes.number,
  clientId: PropTypes.number,
};

export const MissionShape = PropTypes.shape(Mission);
export const MissionExact = PropTypes.exact(Mission);
